/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-07-02 17:53:42
 *
 *******************************************************/
//@flow

import _ from 'lodash';

import React, { Component } from 'react';
import { Card, Button, SkeletonBodyText, SkeletonThumbnail } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { connect } from 'react-redux';
import { routes } from 'src/routes';
import history from 'src/routes/history';
import wellInstall from 'src/assets/images/dashboard/well_installed.png';
import noTheme from 'src/assets/images/dashboard/no_theme.png';
import notLive from 'src/assets/images/dashboard/not_live.png';
import { getLiveThemeStatusHtml, getLiveThemeStatus } from 'src/helpers/theme-setup-helper';
import * as themeSetupAction from 'actions/theme-setup-actions';

type Props = {
  loading: boolean,
  themes: Array<{ role: string }>,
  getThemes: () => void
};

type State = {
  imageLoaded: boolean
};

// Image illustrates for each live theme status
const illustration = {
  wellInstall: wellInstall,
  noTheme: noTheme,
  notLive: notLive,
  loading: ''
};

type ComposedProps = Props & WithI18nProps;
class ThemeSetupStatus extends Component<ComposedProps, State> {
  state = {
    imageLoaded: false
  };

  componentDidMount() {
    const { getThemes } = this.props;

    // Get list of installed theme
    getThemes();
  }
  render() {
    const { themes, loading, i18n } = this.props;
    const { imageLoaded } = this.state;

    // Get the main theme by published status
    const mainTheme = themes.find(theme => theme.published) || themes[0] || {};

    // Get live theme status
    const status = getLiveThemeStatus(loading, mainTheme);

    return (
      <div className="BC-CalloutCard-ThemeSetup__Dashboard">
        <Card>
          <Card.Section>
            <div className="layoutCols">
              <div className="firstCol">
                {loading ? (
                  <SkeletonBodyText lines={5} />
                ) : (
                  <>
                    {getLiveThemeStatusHtml(status, i18n)}
                    <Button
                      size="slim"
                      onClick={() => {
                        history.push(routes.themeSetup.view());
                      }}>
                      {i18n.translate('AdminHTML.Dashboard.ThemeSetupStatus.buttonChildren')}
                    </Button>
                  </>
                )}
              </div>
              <div className="secondCol">
                <div>
                  {loading || !imageLoaded ? <SkeletonThumbnail size="medium" /> : ''}
                  <img
                    src={illustration[status]}
                    alt=""
                    style={{ position: imageLoaded ? undefined : 'absolute' }}
                    onLoad={() => {
                      this.setState({ imageLoaded: true });
                    }}
                  />
                </div>
              </div>
            </div>
          </Card.Section>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  loading: _.get(state.themeSetup, 'getThemesLoading', true),
  themes: _.get(state.themeSetup, 'themes', [])
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  getThemes: () => dispatch(themeSetupAction.getThemes(ownProps.i18n, true))
});

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(ThemeSetupStatus));
